import {
  DiscoverySection,
  GdcSearchBar,
  Roadmap,
  DetailedPlan
} from '@auteco/components/gdcComponents'
import CardTitle from '@auteco/components/sharedComponents/CardTitle'
import React, { useState } from 'react'

const GcdPage = ({ props }) => {
  const [selectOption, setSelectOption] = useState(null)
  const [showBar, setShowBar] = useState(true)
  const [reloadOptions, setReloadOptions] = useState(true)

  const handleSelecterStep = ({ selected }) => {
    setShowBar(false)
    setSelectOption(selected)
  }

  const handleCloseOption = () => {
    setReloadOptions(!reloadOptions)
    setShowBar(true)
    setSelectOption({ ...selectOption, name: '' })
  }
  return (
    <div>
      <CardTitle title="Gestión de Desarrollo Comercial" />
      {showBar ? (
        <GdcSearchBar
          selectOption={selectOption}
          handleSelecterStep={handleSelecterStep}
          reloadOptions={reloadOptions}
        />
      ) : null}
      {selectOption?.name === 'discovery' && (
        <DiscoverySection
          selectOption={selectOption}
          onCloseOption={() => handleCloseOption()}
        />
      )}
      {selectOption?.name === 'hoja_ruta' && (
        <Roadmap
          selectOption={selectOption}
          onCloseOption={() => handleCloseOption()}
        />
      )}
      {selectOption?.name === 'plan_detallado' && (
        <DetailedPlan
          selectOption={selectOption}
          onCloseOption={() => handleCloseOption()}
        />
      )}
    </div>
  )
}

export { GcdPage }
